import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[nextGenerateComponent]'
})
export class GenerateComponentDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
